import { Box, Button, Container, Flex, Grid, GridItem, Heading, Image, Link as LinkR } from "@chakra-ui/react"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, Link } from "@tanstack/react-router"
import { getLandingpage } from "../../api/landingpage"
import PublicationPreview from "../../components/Publications/PublicationPreview"
import LeadPublicationPreview from "../../components/Publications/LeadPublicationPreview"
import PublicationCarouselPreview from "../../components/Publications/PublicationCarouselPreview"
import { getNavigation } from "../../utils"

import jakob from "../../../public/assets/images/jakobmarkt-inserat.jpg"
import NotFound from "../../components/Common/NotFound"

export const Route = createFileRoute("/_layout/")({
  component: Landingpage,
  notFoundComponent: NotFound,
})


function Landingpage() {
  const { data: landingpage } = useQuery({
    ...getLandingpage()
  })

  const { data: navigationPoints } = useQuery(getNavigation())

  const getPath = (catName: string) => {
    const lower = catName.toLowerCase()

    for (const parent of navigationPoints?.data ?? []) {
      if (parent.fk_category.name.toLowerCase() === lower) {
        return parent.path
      }

      const child = parent.children?.find(
        c => c.fk_category.name.toLowerCase() === lower
      )
      if (child) return child.path
    }

    return ""
  }

  return (
    <Container p={{ sm: 4, md: 0 }}>
      {landingpage?.lead_pub &&
        <Box w="100%" mb={10}>
          <LeadPublicationPreview publication={landingpage.lead_pub} />
        </Box>
      }

      {landingpage?.main_pubs &&
        <Grid
          my={10}
          templateColumns={{
            base: "repeat(1, 1fr)",
            lg: "repeat(2, 1fr)",
            xl: "repeat(2, 1fr)",
            "2xl": "repeat(4, 1fr)",
          }}
          gap="2em"
          justifyItems="center"
          justifyContent="center"
        >
          {landingpage.main_pubs.map((pub) => (
            <GridItem
              cursor="pointer"
              key={pub.id}
              w="full"
              h="full"
            >
              <PublicationPreview publication={pub} />
            </GridItem>
          ))}
        </Grid>
      }

      {landingpage?.sub_pubs &&
        <Grid
          my={32}
          templateColumns={{
            base: "repeat(1, 1fr)",
            lg: "repeat(2, 1fr)",
            xl: "repeat(2, 1fr)",
            "2xl": "repeat(4, 1fr)",
          }}
          gap="2em"
          justifyItems="center"
          justifyContent="center"
        >
          {landingpage.sub_pubs.map((pub) => (
            <GridItem
              cursor="pointer"
              key={pub.id}
              w="full"
              h="full"
            >
              <PublicationPreview publication={pub} />
            </GridItem>
          ))}
        </Grid>
      }

      <Flex direction="column" alignItems="center" hideFrom="md" my={32}>
        <LinkR href="https://www.jakob-markt.ch/jakob-schuehparadies.html" target="_blank" w="100%" cursor="pointer"><Image src={jakob} alt="Jakob's Schuehparadies" /></LinkR>
      </Flex>

      {landingpage?.category_pubs &&
        Object.entries(landingpage.category_pubs).map(([catName, cats]) => {
          return (
            <Box key={catName} my={32}>
              <Heading
                size="3xl"
                color="main"
                my={5}
                textAlign={{ base: "center", lg: "unset" }}
                hyphens="auto"
              >
                {catName}
              </Heading>

              <Grid
                templateColumns={{
                  base: "repeat(1, 1fr)",
                  lg: "repeat(2, 1fr)",
                  xl: "repeat(2, 1fr)",
                  "2xl": "repeat(4, 1fr)",
                }}
                gap="2em"
                justifyItems="center"
                justifyContent="center"
              >
                {cats?.map((pub) => (
                  <GridItem
                    cursor="pointer"
                    key={pub.id}
                    w="full"
                    h="full"
                  >
                    <PublicationPreview publication={pub} />
                  </GridItem>
                ))}
              </Grid>

              <Box textAlign="center" my={10}>
                <Link to={getPath(catName)}>
                  <Button variant="secondary">
                    Alle Beiträge anzeigen
                  </Button>
                </Link>
              </Box>
            </Box>
          )
        })
      }

      {landingpage?.rubric_pubs &&
        <Box my={32}>
          <Heading
            size="3xl"
            color="main"
            my={5}
            textAlign={{ base: "center", lg: "unset" }}
            hyphens="auto"
          >
            Das Neuste aus den Rubriken
          </Heading>

          <PublicationCarouselPreview publications={landingpage.rubric_pubs} />
        </Box>
      }
    </Container>
  )
}
